var _rect, _path, _path2, _path3, _path4, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridViewMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666671,
    y: 0.666671,
    width: 30.6668,
    height: 30.6668,
    rx: 3.33333,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 6.6665H7.33342C6.96523 6.6665 6.66675 6.96498 6.66675 7.33317V12.6665C6.66675 13.0347 6.96523 13.3332 7.33342 13.3332H12.6668C13.035 13.3332 13.3335 13.0347 13.3335 12.6665V7.33317C13.3335 6.96498 13.035 6.6665 12.6668 6.6665Z",
    fill: "#7647EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 18.6665H19.3337C18.9655 18.6665 18.667 18.965 18.667 19.3332V24.6665C18.667 25.0347 18.9655 25.3332 19.3337 25.3332H24.667C25.0352 25.3332 25.3337 25.0347 25.3337 24.6665V19.3332C25.3337 18.965 25.0352 18.6665 24.667 18.6665Z",
    fill: "#7647EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 6.6665H19.3337C18.9655 6.6665 18.667 6.96498 18.667 7.33317V12.6665C18.667 13.0347 18.9655 13.3332 19.3337 13.3332H24.667C25.0352 13.3332 25.3337 13.0347 25.3337 12.6665V7.33317C25.3337 6.96498 25.0352 6.6665 24.667 6.6665Z",
    fill: "#7647EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 18.6665H7.33342C6.96523 18.6665 6.66675 18.965 6.66675 19.3332V24.6665C6.66675 25.0347 6.96523 25.3332 7.33342 25.3332H12.6668C13.035 25.3332 13.3335 25.0347 13.3335 24.6665V19.3332C13.3335 18.965 13.035 18.6665 12.6668 18.6665Z",
    fill: "#7647EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666671,
    y: 0.666671,
    width: 30.6668,
    height: 30.6668,
    rx: 3.33333,
    stroke: "#7647EE",
    strokeWidth: 1.33334
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewMenuIcon);
export default __webpack_public_path__ + "static/media/gridViewMenuIcon.f6305a20e890cc7e9129b03d5a8dc06f.svg";
export { ForwardRef as ReactComponent };